export default "__VITE_ASSET__3b3f9a07__"